export const beggingAndChoosingLyrics = [
  { text: "America", start: .5, end: 3.9 },
  { text: "America", start: 3.9, end: 8.2 },
  { text: "You will not", start: 8.2, end: 14 },
  { text: "Tread on me", start: 14, end: 19.4 },
  { text: "Crowd cheers", start: 19.4, end: 27.7 },
  { text: "Fuck donald trump", start: 27.7, end: 28.5 },
  { text: "Oh my gosh Kennedy", start: 28.5, end: 30.2 },
  { text: "You were thinking it", start: 30.2, end: 31.3 },
  { text: "But you actually said it", start: 31.3, end: 32.5 },
  { text: "And I'll say that shit again", start: 32.5, end: 34.3 },
  { text: "Growls", start: 34.3, end: 36.1 },
  { text: "Won't get around beggin and choosin", start: 47, end: 50.1 },
  { text: "Choosin won't won't won't", start: 50.1, end: 51 },
  { text: "Won't get around beggin and choosin", start: 51, end: 53 },
  { text: "Choosin won't won't won't", start: 53, end: 54 },
  { text: "Won't get around beggin and choosin", start: 54, end: 56.4 },
  { text: "Choosin won't won't won't", start: 56.4, end: 57 },
  { text: "Won't get around beggin and choosin choosin", start: 57, end:  59},
  { text: "I've paid my tithes to the American flag ain't got my blessin yet", start: 59, end: 65 },
  { text: "What's a tithe to the American flag", start: 65, end: 68.7 },
  { text: "Hmmm", start: 69, end: 71 },
  { text: "Can't put a tariff on my mind mr president", start: 71, end: 74 },
  { text: "Body on restitution it holds opulence", start: 74, end: 77 },
  { text: "Even in my own home you make me", start: 77, end: 80.4 },
  { text: "Feel out of my element", start: 80.4, end: 83.8 },
  { text: "Soon as I", start: 83.8, end: 85.6 },
  { text: "Refrain from", start: 85.6, end: 86.9 },
  { text: "The constraints you've put me in", start: 86.9, end: 89.47 },
  { text: "Havin a moral compass classifies me as a ruffian", start: 89.47, end: 94.05 },
  { text: "Years I've spent", start: 96, end: 98 },
  { text: "Tryna escape from your grips on my wrists", start: 98, end: 101.04 },
  { text: "It's in my gate and the swing of my hips", start: 101.04, end: 104 },
  { text: "I've been up for ages", start: 104, end: 105.57 },
  { text: "Tearing out pages", start: 105.57, end: 107.1 },
  { text: "This is the story of miss Black america", start: 107.1, end: 112.33 },
  { text: "Long as my tears still fall", start: 112.33, end: 115 },
  { text: "They're used as weaponry", start: 115, end: 117.4 },
  { text: "Freedom just ain't free", start: 117.4, end: 120 },
  { text: "Can't believe I put my hand over my heart for ya", start: 120, end: 122.9 },
  { text: "Si si si singing the melody", start: 122.9, end: 124 },
  { text: "Couldn't be further set apart from ya", start: 124, end: 126 },
  { text: "For too long you have seized snatchin homogeneity", start: 126, end: 128.1 },
  { text: "Is like", start: 128.1, end: 128.5 },
  { text: "Like", start: 128.5, end: 128.7 },
  { text: "Like", start: 128.7, end: 128.9},
  { text: "Like", start: 128.9, end: 129.1 },
  { text: "Like", start: 129.1, end: 129.3 },
  { text: "Like", start: 129.3, end: 129.5 },
  { text: "Like", start: 129.5, end: 129.7 },
  { text: "A work of art to ya", start: 129.7, end: 132 },
  { text: "Per yo doing", start: 132, end: 132.5 },
  { text: "Go figure", start: 132.5, end: 133 },
  { text: "This is yo favorite picture", start: 133, end: 134.4 },
  { text: "You keep recruiting little niggas", start: 134.4, end: 136 },
  { text: "With their finger on the trigga", start: 136, end: 137 },
  { text: "Then get to pointin' the finger like you wasn't involved", start: 137, end: 140 },
  { text: "Then when you cuff em you're praised like it's a problem you solved", start: 140, end: 143.5 },
  { text: "But right up under our nose a new neighbor you've bestowed", start: 143.5, end: 146 },
  { text: "Dressed in little red bows", start: 146, end: 147.3 },
  { text: "Goes by the name of Roscoe", start: 147.3, end: 149.38 },
  { text: "He gots an appetite for overruling you", start: 149.38, end: 152.2 },
  { text: "He starts snatchin dreams", start: 152.2, end: 153.5 },
  { text: "Before the sewers do", start: 153.5, end: 155.14 },
  { text: "He makes it clear", start: 155.14, end: 156 },
  { text: "Makes it known", start: 156, end: 156.8 },
  { text: "Now your house is not a home", start: 156.8, end: 158.5 },
  { text: "Do you remember what it what like to walk the long way home", start: 158.5, end: 162 },
  { text: "Home", start: 162, end: 162.5 },
  { text: "Home", start: 162.5, end: 163 },
  { text: "Home", start: 163, end: 163.5 },
  { text: "Home", start: 163.5, end: 164 },
  { text: "Home", start: 164, end: 164.5 },
  { text: "Home", start: 164.5, end: 165 },
  { text: "Home", start: 165, end: 165.5 },
  { text: "Home", start: 165.5, end: 166.5 },
  { text: "No matter how many lives you've stole", start: 166.5, end: 170 },
  { text: "You can't silence the voice but you can't silence the soul", start: 170, end: 172.9 },
  { text: "Thank god we have music", start: 172.9, end: 176.5 },
  { text: "To escape to when you get to abusing", start: 176.5, end: 179.4 },
  { text: "Your power I know", start: 179.4, end: 182.1 },
  { text: "You will reap what you sow", start: 182.1, end: 185 },
  { text: "You kill women", start: 185, end: 187 },
  { text: "You kill children", start: 187, end: 189 },
  { text: "You let bodies hit the floor", start: 189, end: 192.15 },
  { text: "I won't beg", start: 192.15, end: 193.65 },
  { text: "I won't plead", start: 193.65, end: 195.28 },
  { text: "But I'm sure gon let you know", start: 195.28, end: 198.05 },
  { text: "You will reap what you sow", start: 198.05, end: 201.49 },
  { text: "Mhm co co come out", start: 201.49, end: 203 },
  { text: "So come outside bitch", start: 203, end: 204.5 },
  { text: "Come outside", start: 204.5, end: 205 },
  { text: "Come outside", start: 205, end: 206 },
  { text: "I've got the power I know how to make you fly", start: 206, end: 209 },
  { text: "Make you fly", start: 209, end: 209.5 },
  { text: "But if I gave you wings you'd that it was relative", start: 209.5, end: 212.38 },
  { text: "Just to feed a false and prejudiced narrative", start: 212.38, end: 215.37 },
  { text: "When he says sow the seed", start: 215.37, end: 216.9 },
  { text: "Seed", start: 216.9, end: 217 },
  { text: "Get out and vote for me", start: 217, end: 218.14 },
  { text: "Me", start: 218.14, end: 218.5 },
  { text: "And like a sheep you dismissed freedom for idolatry", start: 218.5, end: 221.36 },
  { text: "A false prophet really gave you a reason", start: 221.36, end: 224.127 },
  { text: "To believe he wouldn't double down on treason", start: 224.127, end: 227.43 },
  { text: "Hmm", start: 227.43, end: 228.39 },
  { text: "Lawd can you hear me", start: 228.39, end: 230 },
  { text: "Blood still drips from the leaves", start: 230, end: 232.88 },
  { text: "From the leaves", start: 232.88, end: 234 },
  { text: "They're bathing in it and they profit from our grief", start: 234, end: 239.18 },
  { text: "The flag", start: 239.18, end: 241.49 },
  { text: "Is drenched with our blood", start: 241.49, end: 244.49 },
  { text: "And people oughta understand that", start: 244.49, end: 246.44 },
  { text: "Iiii I don't see why they don't understand that", start: 246.44, end: 249.43 },
  { text: "They know what they've done to us", start: 249.43, end: 251.15 },
  { text: "All across this country", start: 251.15, end: 253 },
  { text: "They know what they've done to us", start: 253, end: 256.1 },
  { text: "This country is desperately sick", start: 256.1, end: 259.54 },
  { text: "And man is on the critical list", start: 259.54, end: 262.44 },
  { text: "I really don't know where we go from here", start: 262.44, end: 265.30 },
  { text: "Co come outside", start: 267, end: 271.2 },
  { text: "Come outside", start: 270.9, end: 273.6 },
  { text: "Come outside", start: 273.6, end: 276.78 },
  { text: "Come outside", start: 276.78, end: 279 },
  { text: "Side", start: 279, end: 281 },
] as const satisfies ReadonlyArray<{ readonly text: string, readonly start?: number, readonly end?: number }>;
